import { Box, Button, FormControl, Input, Text, VStack } from 'native-base'
import React from 'react'
import validate from 'validate.js'

function Login(props) {
    const { t } = props
    const [validationErrors, setValidationErrors] = React.useState({})
    const [formData, setData] = React.useState({});


    const handleOnSubmitPress = () => {
        let _validationErrors = {}
        const emailContraint = {
            email: {
                email: true
            }
        }
        const emailValidate = validate({ email: formData['email'] }, emailContraint)
        if (emailValidate) {
            _validationErrors['email'] = t('regEmailMessage')
        }
        if (!emailValidate) {
            props.onSubmitPress(formData)
        }
        setValidationErrors(_validationErrors)
    }


    return (
        <Box flex={1} bgColor={"white"} p={2}>
            <VStack space={2} p={6} mt={6} backgroundColor="#ffffff">
                <Text fontSize={"2xl"} fontWeight={700} mb={10}>{t('welcomeBack')}</Text>
                <FormControl my={2} isRequired>
                    <FormControl.Label _text={{ color: 'muted.700', fontSize: 'sm', fontWeight: 400 }}>
                        {t('email')}
                    </FormControl.Label>
                    <Input
                        autoCapitalize={false}
                        onChangeText={(value) => setData({ ...formData, email: value })}
                    />
                    {'email' in validationErrors ?
                        <Text color='red.700' fontSize={'xs'}>{validationErrors.email}</Text>
                        : null
                    }
                </FormControl>
                <FormControl my={2} isRequired>
                    <FormControl.Label _text={{ color: 'muted.700', fontSize: 'sm', fontWeight: 400 }}>
                        {t('password')}
                    </FormControl.Label>
                    <Input
                        type="password"
                        onChangeText={(value) => setData({ ...formData, password: value })}
                    />
                </FormControl>
                <VStack space={2} my={2}>
                    <Button _text={{ color: 'white' }} onPress={() => handleOnSubmitPress()}>
                        {t('signin')}
                    </Button>
                </VStack>
            </VStack>
        </Box>
    )
}

export default Login